/* eslint-disable @typescript-eslint/default-param-last */
import { combineReducers } from 'redux';

import * as types from './types';

export const initState = {};

initState.byID = {};
export const byID = (state = initState.byID, { type, payload }) => {
  switch (type) {
    case types.FETCH_POS.SUCCESS:
      return {
        ...state,
        ...payload.reduce(
          (poses, pos) => ({
            ...poses,
            [pos.pointOfSaleID]: pos,
          }),
          {},
        ),
      };
    default:
      return state;
  }
};

initState.loading = false;
export const loading = (state = initState.loading, { type }) => {
  switch (type) {
    case types.FETCH_POS.START:
      return true;
    case types.FETCH_POS.SUCCESS:
    case types.FETCH_POS.ERROR:
      return false;
    default:
      return state;
  }
};

export default combineReducers({ byID, loading });
